/* Shopify Discount Code Tracker and Cart Manipulator - Cookie-based approach

   this checks if a user came from link with discount '/discount/TUMMYFREE'
  if they came from this link then it checks for the cookie for the discount
  if the cookie exits it checks if there is at least one product in cart then it adds the Tummy Essential 
    product to cart and removes it when no product in cart. 
    
  */

class DiscountCodeTracker {
  constructor(options = {}) {
    this.config = {
      targetDiscountCode: options.targetDiscountCode || 'TUMMYFREE',
      targetProductId: options.targetProductId || '8679046054126',
      targetVariantId: options.targetVariantId || '45870704263406'
    };

    this.init();
  }

  init() {
    this.checkDiscountCookie();
    this.setupCartUpdateListeners();
  }

  checkDiscountCookie() {
    console.log('Checking for discount cookie...');
    
    // Get all cookies from document
    const cookies = document.cookie.split(';');
    
    // Look for discount-related cookies
    let discountCode = null;
    
    // Common Shopify cookie names for discount codes
    const possibleCookieNames = [
      'discount_code',
      'discount',
      '_shopify_discount',
      'cart_currency_discount_code'
    ];
    
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      
      // Check for each possible cookie name
      for (const cookieName of possibleCookieNames) {
        if (cookie.startsWith(`${cookieName}=`)) {
          discountCode = cookie.substring(cookieName.length + 1);
          console.log(`Found discount code in ${cookieName} cookie: ${discountCode}`);
          break;
        }
      }
      
      if (discountCode) break;
    }
    
    // If no specific cookie found, also check for discount in URL for initial visits
    if (!discountCode) {
      const pathname = window.location.pathname;
      if (pathname.startsWith('/discount/')) {
        const pathMatch = pathname.match(/\/discount\/([^\/\?]+)/i);
        if (pathMatch) {
          discountCode = pathMatch[1];
          console.log(`Found discount code in URL path: ${discountCode}`);
        }
      }
    }
    
    // If a discount code was found and matches our target
    if (discountCode && discountCode.toUpperCase() === this.config.targetDiscountCode.toUpperCase()) {
      // Store in sessionStorage for persistence during the session
      sessionStorage.setItem('discountCodeSource', this.config.targetDiscountCode);
      console.log(`Tracked matching discount code: ${discountCode}`);
    } else {
      console.log('No matching discount code found');
    }
  }

  setupCartUpdateListeners() {
    console.log('Setting up Rebuy cart update listeners');
    
    /* Use Rebuy's cart update events to check for cart changes and 
        see if the cart products/items changed 
    */
    
    document.addEventListener('rebuy:cart.change', (event) => {
      console.log('rebuy:cart.change event', event.detail);
      
      // Check if user has the specific discount code
      const discountSource = sessionStorage.getItem('discountCodeSource');
      
      if (discountSource && 
          discountSource.toUpperCase() === this.config.targetDiscountCode.toUpperCase()) {
        this.handleCartUpdate(event.detail.cart);
      }
    });
  }

  handleCartUpdate(cart) {
    // Get the cart items count, excluding our target product
    const nonTargetItemsCount = cart.cart.items.filter(
      item => item.variant_id.toString() !== this.config.targetVariantId.toString()
    ).length;
    
    console.log('Cart update detected, non-target items count:', nonTargetItemsCount);
    console.log('items are one time:', cart.allItemsAreOneTime());

    if (nonTargetItemsCount > 0) {
      console.log('Cart contains at least one non-target product, adding target product');
      this.addTargetProductToCart();
    } else {
      console.log('Cart is empty or only contains target product, removing target product if present');
      this.removeTargetProductFromCart();
    }
  }

  async addTargetProductToCart() {
    try {
      // Check if product is already in cart to prevent duplicates
      const cartContainsProduct = await this.checkIfProductInCart();
      
      if (!cartContainsProduct) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: this.config.targetVariantId,
            quantity: 1
          })
        });
        
        console.log('Target product added to cart');
      } else {
        console.log('Product already in cart, skipping add');
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
    }
  }

  async removeTargetProductFromCart() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the line item for the target product
      const targetLineItem = cart.items.find(
        item => item.variant_id.toString() === this.config.targetVariantId.toString()
      );
      
      if (targetLineItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: targetLineItem.key,
            quantity: 0
          })
        });
        
        console.log('Target product removed from cart');
      } else {
        console.log('Target product not in cart, nothing to remove');
      }
    } catch (error) {
      console.error('Error removing product from cart:', error);
    }
  }

  async checkIfProductInCart() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Convert to string for safer comparison
      return cart.items.some(
        item => item.variant_id.toString() === this.config.targetVariantId.toString()
      );
    } catch (error) {
      console.error('Error checking cart contents:', error);
      return false;
    }
  }
}

// Initialize the tracker
const discountTracker = new DiscountCodeTracker({
  targetDiscountCode: 'TUMMYFREE',
  targetProductId: '8679046054126',
  targetVariantId: '45870704263406'
});